export const templateMapper = {
    "30.48_33.02": {
        name: "12\" to 13\" Wide",
        items: [
            {
                image: "12-13/1213 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "12_13/1213 Cutlery.json",
                imageSide: "12-13/1213 cutlery side.png"
            },
            {
                image: "12-13/1213 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "12_13/1213 Knife Block A.json",
                imageSide: "12-13/1213 knife block A side.png"
            },
            {
                image: "12-13/1213 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "12_13/1213 Knife Block B.json",
                imageSide: "12-13/1213 knife block B side.png"
            },
            {
                image: "12-13/1213 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "12_13/1213 Spice Rack.json",
                imageSide: "12-13/1213 spice rack side.png"
            },
            {
                image: "12-13/1213 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "12_13/1213 Utensils.json",
                imageSide: "12-13/1213 utensils side.png"
            }
        ]
    },
    "33.02_35.56": {
        name: "13\" to 14\" Wide",
        items: [
            {
                image: "13-14/1314 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "13_14/1314 cutlery.json",
                imageSide: "13-14/1314 cutlery side.png"
            },
            {
                image: "13-14/1314 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "13_14/1314 knife block A.json",
                imageSide: "13-14/1314 knife block A side.png"
            },
            {
                image: "13-14/1314 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "13_14/1314 knife block B.json",
                imageSide: "13-14/1314 knife block B side.png"
            },
            {
                image: "13-14/1314 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "13_14/1314 spice rack.json",
                imageSide: "13-14/1314 spice rack side.png"
            },
            {
                image: "13-14/1314 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "13_14/1314 utensils.json",
                imageSide: "13-14/1314 utensils side.png"
            }
        ]
    },
    "35.56_38.10": {
        name: "14\" to 15\" Wide",
        items: [
            {
                image: "14-15/1415 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "14_15/1415 cutlery.json",
                imageSide: "14-15/1415 cutlery side.png"
            },
            {
                image: "14-15/1415 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "14_15/1415 knife block A.json",
                imageSide: "14-15/1415knife block A side.png"
            },
            {
                image: "14-15/1415 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "14_15/1415 knife block B.json",
                imageSide: "14-15/1415 knife block B side.png"
            },
            {
                image: "14-15/1415 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "14_15/1415 spice rack.json",
                imageSide: "14-15/1415 spice rack side.png"
            },
            {
                image: "14-15/1415 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "14_15/1415 utensils.json",
                imageSide: "14-15/1415 utensils side.png"
            }
        ]
    },
    "38.10_40.64": {
        name: "15\" to 16\" Wide",
        items: [
            {
                image: "15-16/1516 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "15_16/1516 cutlery.json",
                imageSide: "15-16/1516 cutlery side.png"
            },
            {
                image: "15-16/1516 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "15_16/1516 knife block A.json",
                imageSide: "15-16/1516 knife block A side.png"
            },
            {
                image: "15-16/1516 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "15_16/1516 knife Block B.json",
                imageSide: "15-16/1516 knife block B side.png"
            },
            {
                image: "15-16/1516 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "15_16/1516 spice rack.json",
                imageSide: "15-16/1516 spice rack side.png"
            },
            {
                image: "15-16/1516 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "15_16/1516 utensils.json",
                imageSide: "15-16/1516 utensils side.png"
            }
        ]
    },
    "40.64_43.18": {
        name: "16\" to 17\" Wide",
        items: [
            {
                image: "16-17/1617 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "16_17/1617 cutlery.json",
                imageSide: "16-17/1617 cutlery side.png"
            },
            {
                image: "16-17/1617 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "16_17/1617 knife block A.json",
                imageSide: "16-17/1617 knife block A side.png"
            },
            {
                image: "16-17/1617 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "16_17/1617 knife block B.json",
                imageSide: "16-17/1617 knife block B side.png"
            },
            {
                image: "16-17/1617 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "16_17/1617 spice rack.json",
                imageSide: "16-17/1617 spice rack side.png"
            },
            {
                image: "16-17/1617 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "16_17/1617 utensils.json",
                imageSide: "16-17/1617 utensils side.png"
            }
        ]
    },
    "43.18_45.72": {
        name: "17\" to 18\" Wide",
        items: [
            {
                image: "17-18/1718 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "17_18/1718 cutlery.json",
                imageSide: "17-18/1718 cutlery side.png"
            },
            {
                image: "17-18/1718 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "17_18/1718 knife block A.json",
                imageSide: "17-18/1718 knife block A side.png"
            },
            {
                image: "17-18/1718 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "17_18/1718 knife block B.json",
                imageSide: "17-18/1718 knife block B side.png"
            },
            {
                image: "17-18/1718 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "17_18/1718 spice rack.json",
                imageSide: "17-18/1718 spice rack side.png"
            },
            {
                image: "17-18/1718 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "17_18/1718 utensils.json",
                imageSide: "17-18/1718 utensils side.png"
            }
        ]
    },
    "45.72_48.26": {
        name: "18\" to 19\" Wide",
        items: [
            {
                image: "18-19/1819 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "18_19/1819 cutlery.json",
                imageSide: "18-19/1819 cutlery side.png"
            },
            {
                image: "18-19/1819 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "18_19/1819 knife block A.json",
                imageSide: "18-19/1819 knife block A side.png"
            },
            {
                image: "18-19/1819 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "18_19/1819 knife block B.json",
                imageSide: "18-19/1819 knife block B side.png"
            },
            {
                image: "18-19/1819 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "18_19/1819 spice rack.json",
                imageSide: "18-19/1819 spice rack side.png"
            },
            {
                image: "18-19/1819 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "18_19/1819 utensils.json",
                imageSide: "18-19/1819 utensils side.png"
            }
        ]
    },
    "48.26_50.80": {
        name: "19\" to 20\" Wide",
        items: [
            {
                image: "19-20/1920 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "19_20/1920 cutlery.json",
                imageSide: "19-20/1920 cutlery side.png"
            },
            {
                image: "19-20/1920 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "19_20/1920 knife block A.json",
                imageSide: "19-20/1920 knife block A side.png"
            },
            {
                image: "19-20/1920 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "19_20/1920 knife block B.json",
                imageSide: "19-20/1920 knife block B side.png"
            },
            {
                image: "19-20/1920 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "19_20/1920 spice rack.json",
                imageSide: "19-20/1920 spice rack side.png"
            },
            {
                image: "19-20/1920 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "19_20/1920 utensils.json",
                imageSide: "19-20/1920 utensils side.png"
            }
        ]
    },
    "50.80_53.34": {
        name: "20\" to 21\" Wide",
        items: [
            {
                image: "20-21/2021 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "20_21/2021 cutlery.json",
                imageSide: "20-21/2021 cutlery side.png"
            },
            {
                image: "20-21/2021 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "20_21/2021 knife block A.json",
                imageSide: "20-21/2021 knife block A side.png"
            },
            {
                image: "20-21/2021 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "20_21/2021 knife block B.json",
                imageSide: "20-21/2021 knife block B side.png"
            },
            {
                image: "20-21/2021 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "20_21/2021 spice rack.json",
                imageSide: "20-21/2021 spice rack side.png"
            },
            {
                image: "20-21/2021 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "20_21/2021 utensils.json",
                imageSide: "20-21/2021 utensils side.png"
            }
        ]
    },
    "53.34_55.88": {
        name: "21\" to 22\" Wide",
        items: [
            {
                image: "21-22/2122 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "21_22/2122 cutlery.json",
                imageSide: "21-22/2122 cutlery side.png"
            },
            {
                image: "21-22/2122 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "21_22/2122 knife block A.json",
                imageSide: "21-22/2122 knife block A side.png"
            },
            {
                image: "21-22/2122 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "21_22/2122 knife block B.json",
                imageSide: "21-22/2122 knife block B side.png"
            },
            {
                image: "21-22/2122 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "21_22/2122 spice rack.json",
                imageSide: "21-22/2122 spice rack side.png"
            },
            {
                image: "21-22/2122 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "21_22/2122 utensils.json",
                imageSide: "21-22/2122 utensils side.png"
            }
        ]
    },
    "55.88_58.42": {
        name: "22\" to 23\" Wide",
        items: [
            {
                image: "22-23/2223 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "22_23/2223 cutlery.json",
                imageSide: "22-23/2223 cutlery side.png"
            },
            {
                image: "22-23/2223 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "22_23/2223 knife block A.json",
                imageSide: "22-23/2223 knife block A side.png"
            },
            {
                image: "22-23/2223 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "22_23/2223 knife block B.json",
                imageSide: "22-23/2223 knife block B side.png"
            },
            {
                image: "22-23/2223 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "22_23/2223 spice rack.json",
                imageSide: "22-23/2223 spice rack side.png"
            },
            {
                image: "22-23/2223 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "22_23/2223 utensils.json",
                imageSide: "22-23/2223 utensils side.png"
            }
        ]
    },
    "58.42_60.96": {
        name: "23\" to 24\" Wide",
        items: [
            {
                image: "23-24/2324 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "23_24/2324 cutlery.json",
                imageSide: "23-24/2324 cutlery side.png"
            },
            {
                image: "23-24/2324 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "23_24/2324 knife block A.json",
                imageSide: "23-24/2324 knife block A side.png"
            },
            {
                image: "23-24/2324 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "23_24/2324 knife block B.json",
                imageSide: "23-24/2324 knife block B side.png"
            },
            {
                image: "23-24/2324 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "23_24/2324 spice rack.json",
                imageSide: "23-24/2324 spice rack side.png"
            },
            {
                image: "23-24/2324 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "23_24/2324 utensils.json",
                imageSide: "23-24/2324 utensils side.png"
            }
        ]
    },
    "60.96_63.50": {
        name: "24\" to 25\" Wide",
        items: [
            {
                image: "24-25/2425 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "24_25/2425 cutlery.json",
                imageSide: "24-25/2425 cutlery side.png"
            },
            {
                image: "24-25/2425 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "24_25/2425 knife block A.json",
                imageSide: "24-25/2425 knife block A side.png"
            },
            {
                image: "24-25/2425 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "24_25/2425 knife block B.json",
                imageSide: "24-25/2425 knife block B side.png"
            },
            {
                image: "24-25/2425 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "24_25/2425 spice rack.json",
                imageSide: "24-25/2425 spice rack side.png"
            },
            {
                image: "24-25/2425 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "24_25/2425 utensils.json",
                imageSide: "24-25/2425 utensils side.png"
            }
        ]
    },
    "63.50_66.04": {
        name: "25\" to 26\" Wide",
        items: [
            {
                image: "25-26/2526 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "25_26/2526 cutlery.json",
                imageSide: "25-26/2526 cutlery side.png"
            },
            {
                image: "25-26/2526 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "25_26/2526 knife block A.json",
                imageSide: "25-26/2526 knife block A side.png"
            },
            {
                image: "25-26/2526 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "25_26/2526 knife block B.json",
                imageSide: "25-26/2526 knife block B side.png"
            },
            {
                image: "25-26/2526 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "25_26/2526 spice rack.json",
                imageSide: "25-26/2526 spice rack side.png"
            },
            {
                image: "25-26/2526 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "25_26/2526 utensils.json",
                imageSide: "25-26/2526 utensils side.png"
            }
        ]
    },
    "66.04_68.58": {
        name: "26\" to 27\" Wide",
        items: [
            {
                image: "26-27/2627 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "26_27/2627 cutlery.json",
                imageSide: "26-27/2627 cutlery side.png"
            },
            {
                image: "26-27/2627 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "26_27/2627 knife block A.json",
                imageSide: "26-27/2627 knife block A side.png"
            },
            {
                image: "26-27/2627 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "26_27/2627 knife block B.json",
                imageSide: "26-27/2627 knife block B side.png"
            },
            {
                image: "26-27/2627 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "26_27/2627 spice rack.json",
                imageSide: "26-27/2627 spice rack side.png"
            },
            {
                image: "26-27/2627 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "26_27/2627 utensils.json",
                imageSide: "26-27/2627 utensils side.png"
            }
        ]
    },
    "68.58_71.12": {
        name: "27\" to 28\" Wide",
        items: [
            {
                image: "27-28/2728 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "27_28/2728 cutlery.json",
                imageSide: "27-28/2728 cutlery side.png"
            },
            {
                image: "27-28/2728 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "27_28/2728 knife block A.json",
                imageSide: "27-28/2728 knife block A side.png"
            },
            {
                image: "27-28/2728 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "27_28/2728 knife block B.json",
                imageSide: "27-28/2728 knife block B side.png"
            },
            {
                image: "27-28/2728 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "27_28/2728 spice rack.json",
                imageSide: "27-28/2728 spice rack side.png"
            },
            {
                image: "27-28/2728 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "27_28/2728 utensils.json",
                imageSide: "27-28/2728 utensils side.png"
            }
        ]
    },
    "71.12_73.66": {
        name: "28\" to 29\" Wide",
        items: [
            {
                image: "28-29/2829 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "28_29/2829 cutlery.json",
                imageSide: "28-29/2829 cutlery side.png"
            },
            {
                image: "28-29/2829 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "28_29/2829 knife block A.json",
                imageSide: "28-29/2829 knife block A side.png"
            },
            {
                image: "28-29/2829 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "28_29/2829 knife block B.json",
                imageSide: "28-29/2829 knife block B side.png"
            },
            {
                image: "28-29/2829 spice rack top.png",
                name: "Spice Rack",
                description: "",
                storageLocation: "28_29/2829 spice rack.json",
                imageSide: "28-29/2829 spice rack side.png"
            },
            {
                image: "28-29/2829 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "28_29/2829 utensils.json",
                imageSide: "28-29/2829 utensils side.png"
            }
        ]
    },
    "73.66_76.20": {
        name: "29\" to 30\" Wide",
        items: [
            {
                image: "29-30/2930 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "29_30/2930 cutlery.json",
                imageSide: "29-30/2930 cutlery side.png"
            },
            {
                image: "29-30/2930 knife block A side.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "29_30/2930 knife block A.json",
                imageSide: "29-30/2930 knife block A top.png"
            },
            {
                image: "29-30/2930 knife block B side.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "29_30/2930 knife block B.json",
                imageSide: "29-30/2930 knife block B top.png"
            },
            {
                image: "29-30/2930 spice rack A side.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "29_30/2930 spice rack A.json",
                imageSide: "29-30/2930 spice rack A top.png"
            },
            {
                image: "29-30/2930 spice rack B side.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "29_30/2930 spice rack B.json",
                imageSide: "29-30/2930 spice rack B top.png"
            },
            {
                image: "29-30/2930 spice rack C side.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "29_30/2930 spice rack C.json",
                imageSide: "29-30/2930 spice rack C top.png"
            },
            {
                image: "29-30/2930 spice rack D side.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "29_30/2930 spice rack D.json",
                imageSide: "29-30/2930 spice rack D top.png"
            },
            {
                image: "29-30/2930 spice rack E side.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "29_30/2930 spice rack E.json",
                imageSide: "29-30/2930 spice rack E top.png"
            },
            {
                image: "29-30/2930 spice rack F side.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "29_30/2930 spice rack F.json",
                imageSide: "29-30/2930 spice rack F top.png"
            },
            {
                image: "29-30/2930 utensils side.png",
                name: "Utensils",
                description: "",
                storageLocation: "29_30/2930 utensils.json",
                imageSide: "29-30/2930 utensils top.png"
            }
        ]
    },
    "76.20_78.74": {
        name: "30\" to 31\" Wide",
        items: [
            {
                image: "30-31/3031 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "30_31/3031 cutlery.json",
                imageSide: "30-31/3031 cutlery side.png"
            },
            {
                image: "30-31/3031 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "30_31/3031 knife block A.json",
                imageSide: "30-31/3031 knife block A side.png"
            },
            {
                image: "30-31/3031 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "30_31/3031 knife block B.json",
                imageSide: "30-31/3031 knife block B side.png"
            },
            {
                image: "30-31/3031 spice rack A top.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "30_31/3031 spice rack A.json",
                imageSide: "30-31/3031 spice rack A side.png"
            },
            {
                image: "30-31/3031 spice rack B top.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "30_31/3031 spice rack B.json",
                imageSide: "30-31/3031 spice rack B side.png"
            },
            {
                image: "30-31/3031 spice rack C top.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "30_31/3031 spice rack C.json",
                imageSide: "30-31/3031 spice rack C side.png"
            },
            {
                image: "30-31/3031 spice rack D top.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "30_31/3031 spice rack D.json",
                imageSide: "30-31/3031 spice rack D side.png"
            },
            {
                image: "30-31/3031 spice rack E top.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "30_31/3031 spice rack E.json",
                imageSide: "30-31/3031 spice rack E side.png"
            },
            {
                image: "30-31/3031 spice rack F top.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "30_31/3031 spice rack F.json",
                imageSide: "30-31/3031 spice rack F side.png"
            },
            {
                image: "30-31/3031 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "30_31/3031 utensils.json",
                imageSide: "30-31/3031 utensils side.png"
            }
        ]
    },
    "78.74_81.28": {
        name: "31\" to 32\" Wide",
        items: [
            {
                image: "31-32/3132 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "31_32/3132 cutlery.json",
                imageSide: "31-32/3132 cutlery side.png"
            },
            {
                image: "31-32/3132 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "31_32/3132 knife block A.json",
                imageSide: "31-32/3132 knife block A side.png"
            },
            {
                image: "31-32/3132 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "31_32/3132 knife block B.json",
                imageSide: "31-32/3132 knife block B side.png"
            },
            {
                image: "31-32/3132 spice rack A top.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "31_32/3132 spice rack A.json",
                imageSide: "31-32/3132 spice rack A side.png"
            },
            {
                image: "31-32/3132 spice rack B top.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "31_32/3132 spice rack B.json",
                imageSide: "31-32/3132 spice rack B side.png"
            },
            {
                image: "31-32/3132 spice rack C top.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "31_32/3132 spice rack C.json",
                imageSide: "31-32/3132 spice rack C side.png"
            },
            {
                image: "31-32/3132 spice rack D top.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "31_32/3132 spice rack D.json",
                imageSide: "31-32/3132 spice rack D side.png"
            },
            {
                image: "31-32/3132 spice rack E top.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "31_32/3132 spice rack E.json",
                imageSide: "31-32/3132 spice rack E side.png"
            },
            {
                image: "31-32/3132 spice rack F top.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "31_32/3132 spice rack F.json",
                imageSide: "31-32/3132 spice rack F side.png"
            },
            {
                image: "31-32/3132 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "31_32/3132 utensils.json",
                imageSide: "31-32/3132 utensils side.png"
            }
        ]
    },
    "81.28_83.82": {
        name: "32\" to 33\" Wide",
        items: [
            {
                image: "32-33/3233 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "32_33/3233 cutlery.json",
                imageSide: "32-33/3233 cutlery side.png"
            },
            {
                image: "32-33/3233 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "32_33/3233 knife block A.json",
                imageSide: "32-33/3233 knife block A side.png"
            },
            {
                image: "32-33/3233 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "32_33/3233 knife block B.json",
                imageSide: "32-33/3233 knife block B side.png"
            },
            {
                image: "32-33/3233 spice rack A top.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "32_33/3233 spice rack A.json",
                imageSide: "32-33/3233 spice rack A side.png"
            },
            {
                image: "32-33/3233 spice rack B top.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "32_33/3233 spice rack B.json",
                imageSide: "32-33/3233 spice rack B side.png"
            },
            {
                image: "32-33/3233 spice rack C top.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "32_33/3233 spice rack C.json",
                imageSide: "32-33/3233 spice rack C side.png"
            },
            {
                image: "32-33/3233 spice rack D top.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "32_33/3233 spice rack D.json",
                imageSide: "32-33/3233 spice rack D side.png"
            },
            {
                image: "32-33/3233 spice rack E top.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "32_33/3233 spice rack E.json",
                imageSide: "32-33/3233 spice rack E side.png"
            },
            {
                image: "32-33/3233 spice rack F top.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "32_33/3233 spice rack F.json",
                imageSide: "32-33/3233 spice rack F side.png"
            },
            {
                image: "32-33/3233 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "32_33/3233 utensils.json",
                imageSide: "32-33/3233 utensils side.png"
            }
        ]
    },
    "83.82_86.36": {
        name: "33\" to 34\" Wide",
        items: [
            {
                image: "33-34/3334 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "33_34/3334 cutlery.json",
                imageSide: "33-34/3334 cutlery side.png"
            },
            {
                image: "33-34/3334 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "33_34/3334 knife block A.json",
                imageSide: "33-34/3334 knife block A side.png"
            },
            {
                image: "33-34/3334 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "33_34/3334 knife block B.json",
                imageSide: "33-34/3334 knife block B side.png"
            },
            {
                image: "33-34/3334 spice rack A top.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "33_34/3334 spice rack A.json",
                imageSide: "33-34/3334 spice rack A side.png"
            },
            {
                image: "33-34/3334 spice rack B top.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "33_34/3334 spice rack B.json",
                imageSide: "33-34/3334 spice rack B side.png"
            },
            {
                image: "33-34/3334 spice rack C top.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "33_34/3334 spice rack C.json",
                imageSide: "33-34/3334 spice rack C side.png"
            },
            {
                image: "33-34/3334 spice rack D top.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "33_34/3334 spice rack D.json",
                imageSide: "33-34/3334 spice rack D side.png"
            },
            {
                image: "33-34/3334 spice rack E top.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "33_34/3334 spice rack E.json",
                imageSide: "33-34/3334 spice rack E side.png"
            },
            {
                image: "33-34/3334 spice rack F top.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "33_34/3334 spice rack F.json",
                imageSide: "33-34/3334 spice rack F side.png"
            },
            {
                image: "33-34/3334 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "33_34/3334 utensils.json",
                imageSide: "33-34/3334 utensils side.png"
            }
        ]
    },
    "86.36_88.90": {
        name: "34\" to 35\" Wide",
        items: [
            {
                image: "34-35/3435 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "34_35/3435 cutlery.json",
                imageSide: "34-35/3435 cutlery side.png"
            },
            {
                image: "34-35/3435 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "34_35/3435 knife block A.json",
                imageSide: "34-35/3435 knife block A side.png"
            },
            {
                image: "34-35/3435 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "34_35/3435 knife block B.json",
                imageSide: "34-35/3435 knife block B side.png"
            },
            {
                image: "34-35/3435 spice rack A top.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "34_35/3435 spice rack A.json",
                imageSide: "34-35/3435 spice rack A side.png"
            },
            {
                image: "34-35/3435 spice rack B top.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "34_35/3435 spice rack B.json",
                imageSide: "34-35/3435 spice rack B side.png"
            },
            {
                image: "34-35/3435 spice rack C top.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "34_35/3435 spice rack C.json",
                imageSide: "34-35/3435 spice rack C side.png"
            },
            {
                image: "34-35/3435 spice rack D top.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "34_35/3435 spice rack D.json",
                imageSide: "34-35/3435 spice rack D side.png"
            },
            {
                image: "34-35/3435 spice rack E top.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "34_35/3435 spice rack E.json",
                imageSide: "34-35/3435 spice rack E side.png"
            },
            {
                image: "34-35/3435 spice rack F top.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "34_35/3435 spice rack F.json",
                imageSide: "34-35/3435 spice rack F side.png"
            },
            {
                image: "34-35/3435 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "34_35/3435 utensils.json",
                imageSide: "34-35/3435 utensils side.png"
            }
        ]
    },
    "88.90_91.44": {
        name: "35\" to 36\" Wide",
        items: [
            {
                image: "35-36/3536 cutlery top.png",
                name: "Cutlery",
                description: "",
                storageLocation: "35_36/3536 cutlery.json",
                imageSide: "35-36/3536 cutlery side.png"
            },
            {
                image: "35-36/3536 knife block A top.png",
                name: "Knife Block A",
                description: "",
                storageLocation: "35_36/3536 knife block A.json",
                imageSide: "35-36/3536 knife block A side.png"
            },
            {
                image: "35-36/3536 knife block B top.png",
                name: "Knife Block B",
                description: "",
                storageLocation: "35_36/3536 knife block B.json",
                imageSide: "35-36/3536 knife block B side.png"
            },
            {
                image: "35-36/3536 knife block C top.png",
                name: "Knife Block C",
                description: "",
                storageLocation: "35_36/3536 knife block C.json",
                imageSide: "35-36/3536 knife block C side.png"
            },
            {
                image: "35-36/3536 spice rack A top.png",
                name: "Spice Rack A",
                description: "",
                storageLocation: "35_36/3536 spice rack A.json",
                imageSide: "35-36/3536 spice rack A side.png"
            },
            {
                image: "35-36/3536 spice rack B top.png",
                name: "Spice Rack B",
                description: "",
                storageLocation: "35_36/3536 spice rack B.json",
                imageSide: "35-36/3536 spice rack B side.png"
            },
            {
                image: "35-36/3536 spice rack C top.png",
                name: "Spice Rack C",
                description: "",
                storageLocation: "35_36/3536 spice rack C.json",
                imageSide: "35-36/3536 spice rack C side.png"
            },
            {
                image: "35-36/3536 spice rack D top.png",
                name: "Spice Rack D",
                description: "",
                storageLocation: "35_36/3536 spice rack D.json",
                imageSide: "35-36/3536 spice rack D side.png"
            },
            {
                image: "35-36/3536 spice rack E top.png",
                name: "Spice Rack E",
                description: "",
                storageLocation: "35_36/3536 spice rack E.json",
                imageSide: "35-36/3536 spice rack E side.png"
            },
            {
                image: "35-36/3536 spice rack F top.png",
                name: "Spice Rack F",
                description: "",
                storageLocation: "35_36/3536 spice rack F.json",
                imageSide: "35-36/3536 spice rack F side.png"
            },
            {
                image: "35-36/3536 utensils top.png",
                name: "Utensils",
                description: "",
                storageLocation: "35_36/3536 utensils.json",
                imageSide: "35-36/3536 utensils side.png"
            }
        ]
    },
}